import script from "./WhitePaperView.vue?vue&type=script&setup=true&lang=js"
export * from "./WhitePaperView.vue?vue&type=script&setup=true&lang=js"

import "./WhitePaperView.vue?vue&type=style&index=0&id=d657e244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d657e244"]])

export default __exports__